export default "__VITE_ASSET__zlFVujwI__"